// removed by extract-text-webpack-plugin
module.exports = {"ui":"select_ui_dxzgbh","menu":"select_menu_3mafgk","disabled":"select_disabled_4uvtnh","withOpen":"select_withOpen_bref3z"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/input/select/select.scss
// module id = 550
// module chunks = 0